// UserStyle.ts
import { SxProps, Theme } from '@mui/material/styles';

export const containerStyle: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  overflowX: 'auto', // Habilita rolagem horizontal quando necessário
  overflowY: 'hidden', // Mantém o layout estável sem rolagem vertical
  minWidth: '850px', // Define a largura mínima para suportar o Paper
  minHeight: '600px', // Define a altura mínima para suportar o Paper
  width: '80vw',
  height: '100vh',
  backgroundColor: (theme) => (theme.palette.mode === 'dark' ? '#545454' : '#cfe3fc'),
  transition: `background-color 0.8s ease-in-out`,
};

export const paperStyle: SxProps<Theme> = {
  width: 1300, // Define largura fixa do Paper
  height: 750, // Define altura fixa do Paper
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column',
  boxShadow: (theme) => 
    theme.palette.mode === 'dark'
      ? '0px 4px 20px rgba(0, 0, 0, 1.7)' // Sombra mais intensa no modo escuro
      : '0px 4px 20px rgba(0, 0, 0, 0.7)', // Sombra mais leve no modo claro
  padding: (theme) => theme.spacing(2),
  backgroundColor: (theme) => (theme.palette.mode === 'dark' ? '#1a1a1a' : '#e0f6ff'),
  color: (theme) => theme.palette.text.primary,
  transition: `background-color 0.8s ease-in-out`,
};

// Outros estilos mantêm-se inalterados
export const breadcrumbLinkStyle: SxProps<Theme> = {
  cursor: 'pointer',
  color: (theme) => theme.palette.text.primary,
  '&:hover': { color: (theme) => theme.palette.primary.main },
};

export const disabledTextStyle: SxProps<Theme> = {
  color: (theme) => theme.palette.text.disabled,
  textAlign: 'center',
};

export const titleStyle: SxProps<Theme> = {
  textAlign: 'center',
  width: '100%',
};
